import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Ban } from "lucide-react";

export default function AnnulAppointmentDialog({ open, onOpenChange, appointment, onAnnulled }) {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post(`/appointments/${appointment.id}/annul`, { reason });
      toast.success(`Cita anulada. ${data.reversed_cash_txns} movimiento(s) de caja revertido(s).`);
      setReason("");
      onOpenChange(false);
      onAnnulled && onAnnulled();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="annul-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive"><Ban className="w-5 h-5" /> Anular cita finalizada</DialogTitle>
          <DialogDescription>
            La cita volverá a estado <b>Pendiente</b>. Se eliminarán el recibo{appointment?.receipt_number ? ` ${appointment.receipt_number}` : ""}, la evolución registrada, la cuenta por cobrar o cortesía asociada y se revertirán los movimientos de caja. Esta acción queda registrada en auditoría.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="label-eyebrow block mb-1">Motivo de la anulación *</label>
            <textarea
              required rows={3} className="input-flat h-auto py-2" data-testid="annul-reason"
              value={reason} onChange={(e) => setReason(e.target.value)}
              placeholder="Ej. Cobro registrado por error, paciente no asistió…"
            />
          </div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => onOpenChange(false)} className="h-10 px-4 rounded-sm border border-border text-sm hover:bg-muted" data-testid="annul-cancel">Cancelar</button>
            <button type="submit" disabled={loading || !reason.trim()} className="h-10 px-4 rounded-sm bg-destructive text-destructive-foreground text-sm font-bold disabled:opacity-60" data-testid="annul-confirm">
              {loading ? "Anulando…" : "Anular cita"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
